import { useCallback } from 'react';

interface FacebookLoginOptions {
  onSuccess: (response: string) => void;
  onError?: (error: Error) => void;
  scope?: string;
}

export const useFacebookLogin = ({
  onSuccess,
  onError,
  scope = 'email,public_profile',
}: FacebookLoginOptions) => {
  return useCallback(() => {
    if (!window.FB) {
      const error = new Error('Facebook SDK is not loaded, please try again');
      onError?.(error);
      return;
    }

    window.FB.login(
      response => {
        if (response.authResponse && response.authResponse.accessToken) {
          const { accessToken } = response.authResponse;
          onSuccess(accessToken);
        } else if (response.status === 'not_authorized') {
          onError?.(new Error('User did not authorize the app'));
        } else if (response.status === 'unknown') {
          // Ignore this case explicitly, that's when the popup is closed
        } else {
          onError?.(new Error('Unexpected login failure'));
        }
      },
      { scope },
    );
  }, [onSuccess, onError, scope]);
};
